import ReactPixel from 'react-facebook-pixel';

const options = {
  autoConfig: true, // set to false if you want to handle configs manually
  debug: false,     // set to true for console logs
};

const initFacebookPixel = (pixelId) => {
  ReactPixel.init(pixelId, {}, options);
  ReactPixel.pageView(); // Fire the initial pageview
};

const trackEvent = (eventName, data = {}) => {
  ReactPixel.track(eventName, data);
};

export { initFacebookPixel, trackEvent };
